export let FilterOptionSource = /*#__PURE__*/function (FilterOptionSource) {
  FilterOptionSource["COLLABORATION_GRAPH"] = "COLLABORATION_GRAPH";
  FilterOptionSource["SMART_USER_PICKER"] = "SMART_USER_PICKER";
  FilterOptionSource["RECENT"] = "RECENT";
  FilterOptionSource["SEARCH"] = "SEARCH";
  FilterOptionSource["CURRENT_USER"] = "CURRENT_USER";
  FilterOptionSource["EXTERNAL"] = "EXTERNAL";
  FilterOptionSource["STATIC"] = "STATIC";
  return FilterOptionSource;
}({});